export const desktopContentContainerPaperDivStyle = {
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '50px',
    marginBottom: '50px'
}

export const aboutMeHeaderStyle = {
    textAlign: 'center'
}



// WEBPACK FOOTER //
// ./src/components/about/styles/desktop.js